// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"f34860c1","587":"b99f0f18","673":"4536b035","787":"d16d0675","830":"99fb4e6d","989":"299b6da1"}[chunkId] + ".chunk.js";
};